import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { IconButton, Grid, Typography } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { ProductCard } from './components';
import tipproduse from './data';
import { t } from '../../i18n';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    background:'#CFD8DC', 
    height:'100%',
    overflow: 'auto'
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}));

const ProductList = ({ currentUser }) => {
  const classes = useStyles();
  const [products] = useState(tipproduse);
  const produseVizibile = products;

  return (
    <div className={classes.root} >
      <div className={classes.content}>
        <Grid
          container
          spacing={3}
        >
          {produseVizibile.map(product => (
            <Grid
              item
              key={product.id}
              lg={4}
              md={6}
              xs={12}
            >
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>
      </div>
      <div className={classes.pagination}>
        <Typography variant="caption">{t('productList.pagination')}</Typography>
        <IconButton>
          <ChevronLeftIcon />
        </IconButton>
        <IconButton>
          <ChevronRightIcon />
        </IconButton>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  currentUser: state.user.currentUser
});

export default connect(mapStateToProps)(ProductList);
